export default __webpack_public_path__ + "static/media/Changepassword.e096df05.svg";